import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "./firebase";
import { migrateProject, type Project } from "./types";

export interface CloudMeta {
  id: string;
  title: string;
  updatedAt: number;
}

const COL = "projects";

function clean(data: Project): Project {
  return JSON.parse(JSON.stringify(data)) as Project;
}

export async function listMyProjects(uid: string): Promise<CloudMeta[]> {
  const snap = await getDocs(query(collection(db, COL), where("ownerId", "==", uid)));
  const rows = snap.docs.map((d) => {
    const data = d.data();
    return {
      id: d.id,
      title: String(data.title ?? "Sin nombre"),
      updatedAt: Number(data.updatedAt ?? 0),
    };
  });
  rows.sort((a, b) => b.updatedAt - a.updatedAt);
  return rows;
}

export async function loadProject(id: string, uid: string): Promise<{ title: string; data: Project } | null> {
  const snap = await getDoc(doc(db, COL, id));
  if (!snap.exists()) return null;
  const data = snap.data();
  if (data.ownerId !== uid && !(data.collaborators as string[] | undefined)?.includes(uid)) return null;
  return {
    title: String(data.title ?? "Sin nombre"),
    data: migrateProject(data.data),
  };
}

export async function createProject(uid: string, title: string, data: Project): Promise<string> {
  const now = Date.now();
  const ref = await addDoc(collection(db, COL), {
    ownerId: uid,
    collaborators: [],
    title,
    data: clean(data),
    createdAt: now,
    updatedAt: now,
  });
  return ref.id;
}

export async function saveProject(id: string, title: string, data: Project): Promise<void> {
  await updateDoc(doc(db, COL, id), {
    title,
    data: clean(data),
    updatedAt: Date.now(),
  });
}

export async function removeProject(id: string): Promise<void> {
  await deleteDoc(doc(db, COL, id));
}
